import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Box, CircularProgress } from '@mui/material';
import { setCdlType, clearMoreClassSelection,  clearEndorsements } from '../../../redux/actions/WizardLaunchActions';
import './CDLTypeSelection.scss';
import profileIcon from '../../../assets/img/profile-icon.svg';

function CDLTypeSelection({ setFormState, handleNext }) {
  const dispatch = useDispatch();
  const selectedType = useSelector((state) => state.wizardLaunch.cdlType);
  const dynamicData = useSelector(
    (state) => state.wizardLaunch.screenData.cdl_type
  );
  const isLoading = useSelector(
    (state) => state.wizardLaunch.dynamicDataLoading
  );
  const error = useSelector((state) => state.wizardLaunch.dynamicDataError);
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    if (selectedType?.answer?.id) {
      setSelectedValue(selectedType.answer.id);
    }
  }, [selectedType]);

  const handleTypeSelect = (option) => {

    dispatch(clearEndorsements());
    dispatch(clearMoreClassSelection());
    setSelectedValue(option.answer.id);

    // Update Redux with the complete option object
    dispatch(
      setCdlType({
        id: option.id,
        answer: option.answer,
        next_question_id: option.next_question_id,
        question_answer_id: option.question_answer_id,
      })
    );

    // Update form state with next question info
    setFormState({
      question_id: option.next_question_id,
      userAnswer: {
        question_answer_id: option.question_answer_id,
        answer: option.answer,
        next_question_id: option.next_question_id,
      },
      question_type: 'cdl_type',
    });
    handleNext();
  };

  if (isLoading) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='200px'
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='200px'
      >
        <Typography color='error'>
          Error loading CDL types. Please try again later.
        </Typography>
      </Box>
    );
  }

  return (
    <Box className='box-grid-parent-cdl-type'>
      <Typography className='h5-title' variant='h5' gutterBottom>
        {dynamicData?.question_text || 'Select your CDL type'}
      </Typography>

      <Box className='box-grid-wrap'>
        {dynamicData?.options?.map((option) => (
          <div
            key={option.question_answer_id}
            className={`box-grid-col ${
              selectedValue === option.answer.id ? 'selected' : ''
            }`}
            onClick={() => handleTypeSelect(option)}
          >
            <div className='check-icon-wrap'>
              <img key={`img-${option.question_answer_id}`} src={profileIcon} alt='profile' />
            </div>
            {option.answer.name}
          </div>
        ))}
      </Box>
    </Box>
  );
}

export default CDLTypeSelection;
